import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { DataEntryAccessMatrix } from './DataEntryCenterPage';
import ModuleAccessManager from '../components/ModuleAccessManager';

const AdminDataEntryAccessPage = () => {
  const { user } = useAuth();
  if (user && user.role !== 'super_admin') {
    return <div className="p-8 text-center text-muted-foreground">Super Admin access required</div>;
  }
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <ShieldCheck className="h-7 w-7 text-primary" />
        <div>
          <h1 className="text-2xl font-heading font-bold">Data Entry Access</h1>
          <p className="text-sm text-muted-foreground">Centralized access control — module permissions per user, plus per-role data-entry form access.</p>
        </div>
      </div>
      <Tabs defaultValue="modules">
        <TabsList>
          <TabsTrigger value="modules" data-testid="tab-module-access">Module Permissions (per user)</TabsTrigger>
          <TabsTrigger value="forms" data-testid="tab-form-access">Data Entry Forms (per role)</TabsTrigger>
        </TabsList>
        <TabsContent value="modules" className="mt-4">
          <ModuleAccessManager />
        </TabsContent>
        <TabsContent value="forms" className="mt-4">
          <DataEntryAccessMatrix />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDataEntryAccessPage;
